export default function initMapApi() {
    let head = document.getElementsByTagName('head')[0];
    let scripts: any = head.getElementsByTagName('script');
    let mapScript: any = null;
    let isMapExist = [...scripts].some(script => {
        let src = script.getAttribute('src');
        if (src && src.includes(`https://api-maps.yandex.ru/2.1`)) {
            mapScript = script;
            return true;
        }
        return false;
    });

    let lang = 'ru';
    let mapCode = 'ru_RU';
    switch (lang) {
        case 'en':
            mapCode = 'en_US';
            break;
    }

    if (!isMapExist) {
        mapScript = document.createElement('script');
        mapScript.src = `https://api-maps.yandex.ru/2.1/?load=package.full,vectorEngine.preload&lang=${mapCode}&coordorder=longlat`;
        mapScript.crossorigin = 'anonymous';
        document.getElementsByTagName('head')[0].appendChild(mapScript);
    }

    return mapScript;
};